import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";

let ViewContentRulesRestServiceConfig: IRestfulConfigMap = {
    "viewContentRulesRestService": {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 查询所有定制规则
            getOne: {
                method: "get",
                path: "api/materialViews/:id/viewContentRules",
                testPath: "api/materialViews/:id/viewContentRules",
                paramDefaults: {
                    id: "@id"
                }
            },
            save: {
                method: "post",
                path: "api/materialViews/:smvId/viewContentRules",
                testPath: "api/materialViews/:smvId/viewContentRules",
                paramDefaults: {
                    smvId: "@smvId"
                }
            },
            batchSave: {
                method: "post",
                path: "api/materialViews/:smvId/viewContentRules/batch",
                testPath: "api/materialViews/:smvId/viewContentRules/batch",
                paramDefaults: {
                    smvId: "@smvId"
                }
            },
            complete: {
                method: "post",
                path: "api/materialViews/:smvId/viewContentRules/complete",
                testPath: "api/materialViews/:smvId/viewContentRules/complete",
                paramDefaults: {
                    smvId: "@smvId"
                }
            },
            delete: {
                method: "delete",
                path: "api/materialViews/:smvId/viewContentRules/:id",
                testPath: "api/materialViews/:smvId/viewContentRules/:id",
                paramDefaults: {
                    smvId: "@smvId",
                    id: "@id"
                }
            },
            update: {
                method: "put",
                path: "api/materialViews/:smvId/viewContentRules/:id",
                testPath: "api/materialViews/:smvId/viewContentRules/:id",
                paramDefaults: {
                    smvId: "@smvId",
                    id: "@id"
                }
            }
        }
    }
}

export { ViewContentRulesRestServiceConfig };